import Base from '@studiometa/js-toolkit';
import transition, { setClassesOrStyles } from '@studiometa/js-toolkit/utils/css/transition';
import { isDev } from '../config';

/**
 * Alert class
 */
class Alert extends Base {
  /**
   * Config
   */
  get config() {
    return {
      name: 'Alert',
      log: isDev(),
    };
  }

  /**
   * Close the alert on click on the `close` ref.
   *
   * @return {Function} The component's `close` method.
   */
  get onCloseClick() {
    return this.close;
  }

  /**
   * Close the alert.
   */
  async close() {
    this.$el.setAttribute('aria-hidden', 'true');
    const main = document.querySelector('main[role="main"]');
    await transition(main ?? this.$el, {
      active: 'transition-transform ease-out duration-500',
      to: { transform: `translateY(-${this.$el.offsetHeight}px)` },
    });

    setClassesOrStyles(this.$refs.alert, 'hidden');
    return this;
  }
}

export default Alert;
